/**
 * Creates a mock chat object for character preview functionality
 * Used when viewing a character without an actual chat session
 */
export const createMockChat = (character: any): any => {
  return {
    display_name: character.display_name,
    icon: character.icon,
    bump: async () => {},
    // All methods throw errors since they're not available in preview mode
    addMessage: async () => { throw new Error('Not available in preview mode'); },
    addImageMessage: async () => { throw new Error('Not available in preview mode'); },
    generate: async () => { throw new Error('Not available in preview mode'); },
    regenerate: async () => { throw new Error('Not available in preview mode'); },
    rewindToMessage: async () => { throw new Error('Not available in preview mode'); },
    editMessage: async () => { throw new Error('Not available in preview mode'); },
    setPersona: async () => { throw new Error('Not available in preview mode'); },
    shareSpotifyTrack: async () => { throw new Error('Not available in preview mode'); },
    generateImage: async () => { throw new Error('Not available in preview mode'); },
    addSummary: async () => { throw new Error('Not available in preview mode'); }
  };
}; 